module.exports = __webpack_public_path__ + "img/bg_m.34ff35d3.jpeg";